module.exports = __webpack_public_path__ + "static/media/59.8f10e450.png";